import { render } from "./AccountVerificationDataTable.vue?vue&type=template&id=058a6fc4&scoped=true"
import script from "./AccountVerificationDataTable.vue?vue&type=script&lang=js"
export * from "./AccountVerificationDataTable.vue?vue&type=script&lang=js"

import "./AccountVerificationDataTable.vue?vue&type=style&index=0&id=058a6fc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058a6fc4"]])

export default __exports__